




































import {ReportEnum} from '../../model/types/enums/reportEnum';
import {Getter} from 'vuex-class';
import {GET_PERIOD} from '../../store/modules/reports/types';
import {Period} from '../../model/types/interfaces/Period';
import {i18nMixin} from '../../mixins';
import {Component, Vue} from 'vue-property-decorator';
import FilterMultiSelect from '@/modules/neodash/components/filter-form/filter-multi-select/filterMultiSelect.vue';
import MonthYearForm from '@/modules/neodash/components/filter-form/month-year-form/month-year-form.vue';
import FilterDropDown from '@/modules/neodash/components/filter-form/filter-drop-down/filterDropDown.vue';
import FilterContainer from '@/modules/neodash/components/filter-container/filter-container.vue';
import {NameValue, NameValues} from '@/modules/neodash/model/types/interfaces/NameValue';
import {listAllTypesLocalityLevel} from '@/modules/neodash/model/constants/typeLocalityLevel';
import {Filter} from '@/modules/neodash/pages/marketBreakDown/Filter';
import {listAllSaleTypes} from '@/modules/neodash/model/constants/saleType';
import _ from 'lodash';
import PeriodForm from '@/modules/neodash/components/filter-form/period-form/period-form.vue';
import {FilterOldService} from '@/modules/neodash/services/filterOldService';
import {TypeLocalityLevelEnum} from '@/modules/neodash/model/types/enums/typeLocalityLevelEnum';
import {MarketBreakdownReportTypeEnum} from '@/enums/market-breakdown-report-type.enum';
import {IKeyValues} from '@/interfaces/key-value-interface';
import {FormFilterFields} from '@/modules/neodash/model/types/interfaces/FormFilterFields';

@Component({
  name: 'MarketBreakDownFilter',
  components: {
    PeriodForm,
    FilterMultiSelect,
    FilterContainer,
    FilterDropDown,
    MonthYearForm
  }
})
export default class MarketBreakDownFilter extends Vue {
  @Getter(GET_PERIOD)
  public getPeriod: (key: ReportEnum) => Period;

  public readonly translate = i18nMixin.methods.i18n;

  public readonly keyLabelLocaleType = 'Common.LocaleType';
  public readonly keyLabelClientLocality = 'Common.Locality';
  public readonly keyLabelSaleType = 'Common.SaleType';
  public readonly keyLabelTypeLocalityLevel = 'Filters.Labels.LocalityLevel';
  public readonly keyLabelReportFormat = 'Common.ReportFormat';


  public readonly typesLocalityLevel: NameValues = listAllTypesLocalityLevel();
  public readonly salesTypes: NameValues = listAllSaleTypes();
  public clientLocalities: NameValues = [];
  public localeTypes: NameValues = [];
  public locations: NameValues = [];
  public typeSales: NameValues = [];
  public analysisTypes: NameValues = [
    {
      value: MarketBreakdownReportTypeEnum.registration,
      name: this.translate('Report.RegistrationAnalysis')
    },
    {
      value: MarketBreakdownReportTypeEnum.sales,
      name: this.translate('Report.SalesAnalysis')
    }
  ];

  public filterModel = {
    localeType: null,
    clientLocality: null,
    saleType: null,
    typeLocalityLevel: null,
    period: null
  } as Filter;

  public showReport() {
    this.$emit('input', this.value);
    setTimeout(() => this.$emit('showReport'), 200);
  }

  private get value(): FormFilterFields<Filter> {
    if (!this.formValid)
      return {
        value: {} as Filter,
        labels: []
      } as FormFilterFields<Filter>;

    return {
      value: this.filterModel,
      labels: this.labels
    };
  }

  public async handleTypesLocalityLevel() {
    this.filterModel.localeType = null;
    this.filterModel.saleType = null;
    const {typeLocalityLevel} = this.filterModel;
    if (!typeLocalityLevel || !typeLocalityLevel.value)
      return;

    this.localeTypes = await FilterOldService.getTypeLocalityOnlyOperationalArea(typeLocalityLevel);
    this.typeSales = [];
    this.clientLocalities = [];

    if (this.filterModel.typeLocalityLevel && this.filterModel.typeLocalityLevel.value !== -1) {
      this.filterModel.saleType = { name: this.translate('Varejo'), value: 1 };
    }

    await this.loadClientLocalities();
    await this.loadTypeSales(typeLocalityLevel);
  }

  public async loadClientLocalities() {
    const {typeLocalityLevel, localeType} = this.filterModel;
    if (!typeLocalityLevel || !typeLocalityLevel.value)
      return;

    if (localeType && typeLocalityLevel.value == TypeLocalityLevelEnum.Client) {
      this.clientLocalities = await FilterOldService.getLocalities(localeType as NameValue);
    }
  }

  public async loadTypeSales(localityType: NameValue) {
    const {typeLocalityLevel, localeType} = this.filterModel;
    if (!typeLocalityLevel || !typeLocalityLevel.value || !localeType)
      return;
    if (typeLocalityLevel.value == TypeLocalityLevelEnum.Ibge) {
      this.typeSales = await FilterOldService.getTypeSales(localityType);
    }
  }


  public get labels(): IKeyValues {
    const {translate, keyLabelClientLocality, keyLabelLocaleType, keyLabelReportFormat, keyLabelSaleType, keyLabelTypeLocalityLevel} = this;
    const {analysisType, clientLocality, period, saleType, localeType, typeLocalityLevel} = this.filterModel;

    const [labelClientLocality, labelLocaleType, labelReportFormat, labelSaleType, labelTypeLocalityLevel, labelPeriodInit, labelPeriodEnd]: string[] =
      [keyLabelClientLocality, keyLabelLocaleType, keyLabelReportFormat, keyLabelSaleType, keyLabelTypeLocalityLevel, 'Common.Initial', 'Common.End'].map(x => translate(x));

    const periodsLabel = !!period ? period.label.split(' - ') : ['', '']

    const nameOrEmpty = (value) => (value != null ? value.name : '');

    const labels = [
      {text: labelClientLocality, value: nameOrEmpty(clientLocality)},
      {text: labelLocaleType, value: nameOrEmpty(localeType)},
      {text: labelReportFormat, value: nameOrEmpty(analysisType)},
      {text: labelSaleType, value: nameOrEmpty(saleType)},
      {text: labelTypeLocalityLevel, value: nameOrEmpty(typeLocalityLevel)},
      {text: labelPeriodInit, value: periodsLabel[0]},
      {text: labelPeriodEnd, value: periodsLabel[1]}
    ];

    return labels.filter(x => x.value && x.value != '');
  }

  public get formValid(): boolean {
    let value = this.filterModel;
    value = Object.assign({
      localeType: null,
      clientLocality: null,
      saleType: null,
      typeLocalityLevel: null,
      period: null,
      analysisType: null
    }, value);
    if (value.typeLocalityLevel != null &&
      value.typeLocalityLevel.value == TypeLocalityLevelEnum.Ibge) {
      delete value.clientLocality;
    }
    if (value.typeLocalityLevel != null &&
      value.typeLocalityLevel.value == TypeLocalityLevelEnum.Client) {
      delete value.saleType;
    }
    let formValid = !(_.isEmpty(value));
    for (let member in value) {
      if (!!value[member] && value[member].value != 0) continue;
      formValid = false;
    }
    return formValid;
  }

  public get limits(): Period {
    return this.getPeriod(ReportEnum.MarketBreakDown);
  }

  public async handleLocaleType() {
    this.locations = [];
    this.typeSales = [];

    const {typeLocalityLevel} = this.filterModel;
    if (!typeLocalityLevel)
      return;

    await this.loadClientLocalities();
    await this.loadTypeSales(typeLocalityLevel);
  }
}
